//  Sticky submit button needs to change based on modal that's showing
export const changeUncontrolledSubmitButtonDuplicateForm = ($form) => {
  const $uncontrolledSubmitButtonWrapper = $(".sticky-submit");
  const $uncontrolledSubmitButton = $uncontrolledSubmitButtonWrapper.find(
    "button"
  );
  const formId = $form.attr("id");

  const $modal = $form.parents(".modal");

  $modal.on("show.bs.modal", () => {
    $uncontrolledSubmitButton.attr("form", () => formId);
    const isFormHidden = $form.css("display") === "none";
    if (!isFormHidden) {
      $uncontrolledSubmitButtonWrapper.css("display", "block");
      return;
    }
    $uncontrolledSubmitButtonWrapper.css("display", "none");
  });
};
